var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:{ spin: _vm.spin },domProps:{"innerHTML":_vm._s(_vm.getSvg())}})}
var staticRenderFns = []

export { render, staticRenderFns }